export default __webpack_public_path__ + "static/media/frog.120c16ce.mp4";